var React = require('react');

function TickedBoxInactiveReverseInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M21.4286 23H2.57143C1.70353 23 1 22.2965 1 21.4286V2.57143C1 1.70353 1.70353 1 2.57143 1H21.4286C22.2965 1 23 1.70353 23 2.57143V21.4286C23 22.2965 22.2965 23 21.4286 23Z","stroke":"#76695D","strokeWidth":"2"}));
}

TickedBoxInactiveReverseInline.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = TickedBoxInactiveReverseInline;

TickedBoxInactiveReverseInline.default = TickedBoxInactiveReverseInline;
